// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconStatamnt } from "../../../icons/full/build/icon-statamnt.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const StatamntIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconStatamnt.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  StatamntIcon.displayName = 'StatamntIcon';
}

export default StatamntIcon;